<template>
  <div class="contactus">
    <div class="header">
      <div class="title">联系我们</div>
      <div class="border"></div>
    </div>
    <div class="body">
      畅月数字家园管控系统是畅月所有员工潜心研发的SAAS平台+移动软件+智能硬件为一体的智慧物业平台，拓展智慧社区OTO到家服务，为物业赋能增收，帮助业主实现移动智慧管家，打造智慧社区新生态，构建智慧社区新商业。
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

export default {
  setup() {
    return reactive({});
  },
};
</script>

<style scoped>
.contactus {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}
.body {
    text-align: center;
    margin-top: 40px;
    font-size: 18px;
    color: #495A6C;
}
</style>
